import * as HLF from "html-living-framework";

export class LayoutBitmapText extends PIXI.BitmapText {
    private _textAreaHeight: number = 0;
    set textAreaWidth(value: number) {
        this.maxWidth = value;
    }

    set textAreaHeight(value: number) {
        this._textAreaHeight = value;
    }

    public onLayout() {
        this.fontSize *= HLF.Application.instance.renderer.resolution / 2;
    }
}